import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { IRootState } from 'src/reducers';
import actions from 'src/actions';
import { connect } from 'react-redux';
import SearchResult from 'src/models/OwnerSearchResult';
import selectors from 'src/selectors';
import Card, { CardAction } from 'src/components/common/Card.redesign';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import CardContainer from 'src/components/common/CardContainer.redesign';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import Form from 'src/components/controls/forms/Form';
import * as _ from 'lodash';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import { push } from 'connected-react-router';
import OwnerTracts from './owners/OwnerTracts';
import DialogList from 'src/dialogs';
import ManageDeviationsDialog from './TractComponents/ManageDeviationsDialog';
import IOwner from 'src/models/IOwner';
import MergeContainer from 'src/models/MergeContainer';
import OwnerContactNotes from './owners/OwnerContactNotes';
import Button from 'src/components/controls/forms/redesign/FormButton';
import OwnerNotes from './owners/OwnerNotes';
import AddNewOwnerNote from './owners/OwnerNoteDialog';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
import Project from 'src/models/Project';
import { ODataFilter, ODataFilterOperators, ODataOptions } from 'src/util/ODataBuilder';
import PagedResultSet from 'src/models/common/PagedResultSet';
import ProjectStaff from 'src/models/ProjectStaff';
import OwnershipContactCategoryForm from 'src/models/OwnershipContactCategoryForm';
import '/src/styles/pages/owners.scss';
import OwnershipLeaseBuyer from 'src/models/OwnershipLeaseBuyer';
import { withRouter } from 'react-router-dom';
import AttachedAgreements from './owners/AttachedAgreements';
import AgreementUtil from 'src/util/AgreementUtil';

export interface IOwnerPageStateProps {
    ownerSearchResults: PagedResultSet<SearchResult>;
    ownerDeviationsSearchResults: Array<SearchResult>;
    ownerData: LeaseGenerationOwnerData;
    isLoggedIn: boolean;
    ownerDetails: Array<IOwner>;
    targetOwnerDetails: Array<IOwner>;
    projectStaff: PagedResultSet<ProjectStaff>;
    ownershipContactCategories: OwnershipContactCategoryForm;
    project: (clientNumber: number, projectNumber: number) => Project;
}

type OwnerPageState = {
    searchString: string;
    selectedOwnerId: number;
    searchOwnerType: string;
};

export interface IOwnerPageDispatchProps {
    getPagedOwnerSearchResults: (clientNumber: number, projectNumber: number, options: ODataOptions) => void;
    getOwnerSearchDeviationsResults: (clientNumber: number, projectNumber: number, searchText: string, ownerType: string) => void;
    getOwnerData: (clientId: number, projectId: number, ownerId: number) => void;
    navigate: (path: string) => void;
    showDialog: (dialogName: string) => void;
    hideDialog: () => void;
    changePrimary: (clientNumber: number, projectNumber: number, owner: IOwner) => void;
    separateDeviation: (clientNumber: number, projectNumber: number, owner: IOwner) => void;
    clearTargetDeviations: () => void;
    getOwnerDetail: (clientNumber: number, projectNumber: number, ownerLookupId: number, containerId: number, type: string) => void;
    getTargetOwnerDetail: (clientNumber: number, projectNumber: number, ownerLookupId: number, containerId: number, type: string) => void;
    mergeContainer: (clientNumber: number, projectNumber: number, primaryOwnerId: number, mergeContainer: MergeContainer) => void;
    getProjectDetails: (clientNumber: number, projectNumber: number) => void;
    incrementPage: (clientNumber: number, projectNumber: number, options: ODataOptions) => void;
    getProjectStaff: (clientNumber: number, projectNumber: number) => void;
    getOwnershipContactCategories: (clientNumber: number, projectNumber: number) => void;
    initOwnersPage: () => void;
}

type IOwnerProps = RouteComponentProps<{ clientNumber?: string; projectNumber?: string }> & IOwnerPageStateProps & IOwnerPageDispatchProps;

class OwnersPage extends React.Component<IOwnerProps, OwnerPageState> {
    constructor(props: IOwnerProps) {
        super(props);
    }

    private clientNumber: number;
    private projectNumber: number;
    private dialogCreators: dialogCreators;
    static contextType = DialogContext;

    readonly state: Readonly<OwnerPageState> = {
        searchString: undefined,
        selectedOwnerId: null,
        searchOwnerType: undefined
    };

    public componentDidMount() {
        this.dialogCreators = this.context;
        this.clientNumber = parseInt(this.props.match.params.clientNumber, 10);
        this.projectNumber = parseInt(this.props.match.params.projectNumber, 10);
        const selectedOwnerIdTemp = localStorage.getItem('ownerPage_SelectedOwner');
        const selectedOwnerClient = localStorage.getItem('ownerPage_SelectedTract_Client');
        const selectedOwnerProject = localStorage.getItem('ownerPage_SelectedTract_Project');
        const selectedOwnerId = !!selectedOwnerIdTemp ? Number(selectedOwnerIdTemp) : -1;
        if (!!selectedOwnerClient && !!selectedOwnerProject && selectedOwnerClient === this.clientNumber?.toString() && selectedOwnerProject === this.projectNumber?.toString()) {
            if (!!selectedOwnerId && selectedOwnerId !== -1 && !isNaN(selectedOwnerId)) {
                this.restoreSavedState(selectedOwnerId);
            } else {
                this.props.getPagedOwnerSearchResults(this.clientNumber, this.projectNumber, new ODataOptions());
            }
        } else {
            localStorage.removeItem('ownerPage_SelectedTract');
            localStorage.removeItem('ownerPage_SelectedTract_Client');
            localStorage.removeItem('ownerPage_SelectedTract_Project');
            this.props.getPagedOwnerSearchResults(this.clientNumber, this.projectNumber, new ODataOptions());
        }
        this.props.getProjectDetails(this.clientNumber, this.projectNumber);
        this.props.getProjectStaff(this.clientNumber, this.projectNumber);
        this.props.getOwnershipContactCategories(this.clientNumber, this.projectNumber);
    }

    public restoreSavedState = (selectedOwnerId: number) => {
        this.setState({
            searchOwnerType: 'All',
        });
        const options = new ODataOptions();
        options.addFilter(new ODataFilter('Id', ODataFilterOperators.Equals, selectedOwnerId));
        this.props.getPagedOwnerSearchResults(this.clientNumber, this.projectNumber, options);
        this.setState({ selectedOwnerId: selectedOwnerId });
        this.props.getOwnerData(this.clientNumber, this.projectNumber, selectedOwnerId);
        localStorage.removeItem('ownerPage_SelectedOwner');
        localStorage.removeItem('ownerPage_SelectedTract_Client');
        localStorage.removeItem('ownerPage_SelectedTract_Project');
    }

    public componentWillUnmount() {
        this.props.initOwnersPage();
    }

    searchUpdate = _.debounce((searchText: string) => {
        this.props.initOwnersPage();
        this.setState({ selectedOwnerId: null });
        this.setState({ searchString: searchText });

        const options = new ODataOptions();
        if (searchText === undefined || searchText === '') {
            searchText = '_';
        } else {
            options.addFilter(new ODataFilter('omni', ODataFilterOperators.Contains, searchText));
        }

        this.props.getPagedOwnerSearchResults(this.clientNumber, this.projectNumber, options);
    }, 500);

    editOwner = (ownerId: number) => {
        this.props.navigate(`/clients/${this.clientNumber}/projects/${this.projectNumber}/owners/${ownerId}/edit`);
    };

    showManageDeviationsDialog = (selectedOwnerId: number, containerId: number, type: string) => {
        const projectData: Project = this.props.project(this.clientNumber, this.projectNumber);

        this.dialogCreators.owners.mergeOwners(selectedOwnerId, projectData, this.props.navigate, this.onSuccessfulEdit);

        // NOTE: The rest of this can probably be removed.
        this.props.getOwnerDetail(this.clientNumber, this.projectNumber, selectedOwnerId, containerId, type);

        this.setState({
            selectedOwnerId: selectedOwnerId,
            searchOwnerType: type,
        });
    };

    showConvertOwnerDialog = (selectedOwnerId: number, ownerType: string) => {
        this.dialogCreators.owners.convertOwner(selectedOwnerId, ownerType, this.onSuccessfulEdit);
    };

    showOwnerData = (ownerId: number) => {
        if (ownerId > 0) {
            this.props.getOwnerData(this.clientNumber, this.projectNumber, ownerId);
            this.setState({ selectedOwnerId: ownerId });
            localStorage.setItem('ownerPage_SelectedOwner', ownerId.toString());
        }
    };

    determineOwnerNameClass = (owner: SearchResult) => {
        let className = 'title';
        if (owner.isClientAcreage) {
            className += ' yellow';
        }
        return className;
    };

    onSuccessfulEdit = () => {
        this.props.initOwnersPage();
        this.props.getPagedOwnerSearchResults(this.clientNumber, this.projectNumber, new ODataOptions());
        this.props.getProjectDetails(this.clientNumber, this.projectNumber);
    }

    displayOwnerSearchResults = () => {
        if (this.props.ownerSearchResults?.items) {
            return this.props.ownerSearchResults.items.map((owner: SearchResult) => {
                let defaultActions: CardAction[] = [
                    { text: 'Edit Info', action: () => this.editOwner(owner.id) },
                    { text: 'Manage Deviations', action: () => this.showManageDeviationsDialog(owner.id, owner.containerOwnerId, owner.type) }
                ];

                const cardActions: CardAction[] = owner.type === 'JointTenant'
                    ? defaultActions
                    : defaultActions.concat([{ text: 'Convert Owner Type', action: () => this.showConvertOwnerDialog(owner.id, owner.type)}]);
                let spouseName = !! owner.spouseName ? owner.spouseName.replace(/\s/g, '') : '';

                return (
                    <Card
                        actionPanelStyle={{transform: 'translateY(-1rem) rotate(90deg)'}}
                        key={`owner-${owner.id}`}
                        onClick={() => this.showOwnerData(owner.id)}
                        badge={`Owner #${owner.id}`}
                        actions={cardActions}
                        className={owner.id === this.state.selectedOwnerId ? 'selected' : ''}
                        style={{ marginTop: '1rem' }}
                    >
                        <div style={{ padding: '1rem' }}>
                            <div className={this.determineOwnerNameClass(owner)}>{spouseName.length > 0 ? `${owner.name} & ${owner.spouseName}` : owner.name}</div>
                            <div>{owner.type}</div>
                        </div>
                    </Card>
                );
            });
        } else {
            return <div>No Owners found</div>;
        }
    };

    getOwnerDetail = (ownerLookupId: number, containerId: number, type: string) => {
        this.props.getOwnerDetail(this.clientNumber, this.projectNumber, ownerLookupId, containerId, type);
    };

    getTargetOwnerDetail = (ownerLookupId: number, containerId: number, type: string) => {
        this.props.getTargetOwnerDetail(this.clientNumber, this.projectNumber, ownerLookupId, containerId, type);
    };
    onSearchOwnersDeviations = (searchString: string, ownerType: string) => {
        this.props.getOwnerSearchDeviationsResults(this.clientNumber, this.projectNumber, searchString, ownerType);
    };
    changePrimary = (owner: IOwner) => {
        this.props.changePrimary(this.clientNumber, this.projectNumber, owner);
    };

    separateDeviation = (owner: IOwner) => {
        this.props.separateDeviation(this.clientNumber, this.projectNumber, owner);
    };

    mergeContainer = (primaryOwnerId: number, mergeContainer: MergeContainer) => {
        this.props.mergeContainer(this.clientNumber, this.projectNumber, primaryOwnerId, mergeContainer);
    };

    refreshNotes = () => {
        if (this.props.ownerData?.ownerDetails) {
            this.props.getOwnerData(this.clientNumber, this.projectNumber, this.props.ownerData.ownerDetails.ownerLookUpId);
        } else {
            console.log('no data', this.props.ownerData);
        }
    };

    handleWhereAttached = () => {
        this.dialogCreators.owners.whereAttached(
            this.props.ownerData?.ownerDetails.ownerLookUpId
        );
    };

    handleNewNote = () => {
        this.dialogCreators.owners.manageOwnership(
            this.props.ownerData?.ownerDetails, 
            'Mineral', 
            'Contact Notes', 
            this.props.projectStaff,
            this.props.ownershipContactCategories,
            true, 
            this.refreshNotes
        );
    };

    handleLeaseBuyers = () => {
        this.dialogCreators.owners.manageOwnership(
            this.props.ownerData?.ownerDetails, 
            'Mineral', 
            'Lease Buyers', 
            this.props.projectStaff,
            this.props.ownershipContactCategories,
            true,
            this.refreshNotes,
            null,
            this.handleLeaseBuyerEmails,
        );
    };

    handleContactCategories = () => {
        this.dialogCreators.owners.manageOwnership(
            this.props.ownerData?.ownerDetails, 
            'Mineral', 
            'Contact Categories', 
            this.props.projectStaff,
            this.props.ownershipContactCategories,
            true, 
            this.refreshNotes
        );
    }

    handleNewOwnerNote = () => {
        this.props.showDialog(DialogList.ADD_OWNER_NOTE);
    };

    handleLeaseBuyerEmails = (sendList: OwnershipLeaseBuyer[]) => {
        this.dialogCreators.contract.emailLeaseBuyers(
            sendList,
            this.props.hideDialog
        );
    };

    navToLeasehold = (ownershipId: number, contractId: number, contractholdId: number, contractType: string) => {
        let project = this.props?.project(this.clientNumber, this.projectNumber);
        let tract = this.props?.ownerData?.tracts?.find(ot => ot.ownershipId === ownershipId);
        let tractNumber = tract?.surfaceTractNumber > 0 ? tract.surfaceTractNumber : tract?.tractNumber;

        let parentPath = `/clients/${this.clientNumber}/projects/${this.projectNumber}`;
        let navPath = AgreementUtil.navToLeasehold(ownershipId, contractId, contractholdId, contractType);

        let ownersPath = AgreementUtil.navOwnersToLeasehold(project?.landSystemId, project?.tractTypeName, tract?.sectionNumber, tractNumber, tract?.horizonNumber);

        parentPath += ownersPath;
        this.props.navigate(parentPath + navPath);
    };

    incrementOwners = () => {
        let searchText = '_';
        const options = new ODataOptions();
        if (!!this.state && this.state.searchString !== undefined && this.state.searchString !== '') {
            searchText = this.state.searchString;
        }
        options.addFilter(new ODataFilter('omni', ODataFilterOperators.Contains, searchText));

        this.props.incrementPage(this.clientNumber, this.projectNumber, options);
    };

    public render() {
        const { ownerSearchResults } = this.props;
        let isOnLastPage = false;
        if (ownerSearchResults) {
            isOnLastPage = ownerSearchResults.pageNumber * ownerSearchResults.pageSize < ownerSearchResults.totalRecords;
        }

        return (
            <>
                <Page style={{ display: 'flex', clear: 'both' }}>
                    <Page.Section width={6}>
                        <Panel fitPanelToScreen={true} customSize={2}>
                            <Form onSubmit={() => console.log('form submitted')}>
                                <FormTextBox
                                    name="searchText"
                                    label="Owner Search by Name"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.searchUpdate(e.target.value)}
                                />
                            </Form>
                            <div className="dlc-content-panel-header">Owners</div>
                            <CardContainer 
                                className="owners-page-owner-list"
                                showNextPagePanel={isOnLastPage}
                                nextPageAction={this.incrementOwners}
                                buttonPaging={true}
                                style={{ overflowY: 'scroll' }}
                            >
                                {this.displayOwnerSearchResults()}
                                <div style={{ height: '3rem' }}/>
                            </CardContainer>
                        </Panel>
                    </Page.Section>
                    {this.state.selectedOwnerId && (
                        <Page.Section width={6}>
                            <Panel fitPanelToScreen={true}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                                    <div style={{ marginLeft: '1rem', width: '75%' }} className="dlc-content-panel-header">
                                        Tract List
                                    </div>
                                    <Button text="Where Attached" onClick={this.handleWhereAttached} />
                                </div>
                                <OwnerTracts
                                    tracts={this.props.ownerData && this.props.ownerData.tracts}
                                    clientNumber={this.clientNumber}
                                    projectNumber={this.projectNumber}
                                    navigate={this.props.navigate}
                                    projectData={this.props.project(this.clientNumber, this.projectNumber)}
                                    projectStaff={this.props.projectStaff}
                                    contactCategories={this.props.ownershipContactCategories}
                                    ownerships={this.props.ownerData?.ownerships}
                                />
                            </Panel>

                            <Panel fitPanelToScreen={true}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                                    <div style={{ marginLeft: '1rem', width: '75%' }} className="dlc-content-panel-header">
                                        Attached Agreements
                                    </div>
                                </div>
                                <AttachedAgreements
                                    attachedAgreements={this.props.ownerData?.attachedAgreements ?? []}
                                    ownerLookupId={this.props.ownerData?.ownerDetails?.ownerLookUpId}
                                    shortList={true}
                                    navToLeasehold={this.navToLeasehold}
                                />
                            </Panel>

                            <Panel fitPanelToScreen={true}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                                    <div style={{ marginLeft: '1rem', width: '75%' }} className="dlc-content-panel-header">
                                        Contact Notes
                                    </div>
                                    <Button text="New Contact Note" onClick={this.handleNewNote} />
                                </div>

                                <OwnerContactNotes
                                    ownershipContactCategories={this.props.ownershipContactCategories}
                                    projectStaff={this.props.projectStaff}
                                    contactNotes={this.props.ownerData?.contactNotes}
                                    ownerLookUpId={this.state.selectedOwnerId}
                                    onEditContactNote={this.refreshNotes}
                                    ownerData={this.props.ownerData}
                                    hideDialog={this.props.hideDialog}
                                />
                            </Panel>
                            <Panel fitPanelToScreen={true}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                                    <div
                                        style={
                                            this.props?.ownerData?.ownerDetails?.note
                                                ? { marginLeft: '1rem', width: '95%' }
                                                : { marginLeft: '1rem', width: '75%' }
                                        }
                                        className="dlc-content-panel-header"
                                    >
                                        Owner Note
                                    </div>
                                    {!this.props?.ownerData?.ownerDetails?.note && <Button text="New Owner Note" onClick={this.handleNewOwnerNote} />}
                                </div>
                                <OwnerNotes
                                    ownerData={this.props.ownerData}
                                    ownerLookUpId={this.state.selectedOwnerId}
                                    showDialog={this.props.showDialog}
                                    hideDialog={this.props.hideDialog}
                                    refreshContainer={this.refreshNotes}
                                />
                            </Panel>
                            <Panel fitPanelToScreen={true}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                                    <div style={{ marginLeft: '1rem', width: '60%' }} className="dlc-content-panel-header">
                                        Contact Categories
                                    </div>
                                    <Button text="Manage Contact Categories" onClick={this.handleContactCategories} />
                                </div>
                            </Panel>
                            <Panel fitPanelToScreen={true}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                                    <div style={{ marginLeft: '1rem', width: '65%' }} className="dlc-content-panel-header">
                                        Lease Buyers
                                    </div>
                                    <Button text="Manage Lease Buyers" onClick={this.handleLeaseBuyers} />
                                </div>
                            </Panel>
                        </Page.Section>
                    )}
                </Page>
                {this.state.selectedOwnerId > 0 && (
                    <>
                        <ManageDeviationsDialog
                            ownerId={this.state.selectedOwnerId}
                            dialogName="Manage Deviations"
                            ownerDeviations={this.props.ownerDetails}
                            targetOwnerDeviations={this.props.targetOwnerDetails}
                            changePrimary={this.changePrimary}
                            separateDeviation={this.separateDeviation}
                            searchOwners={this.onSearchOwnersDeviations}
                            searchResults={this.props.ownerDeviationsSearchResults}
                            getOwnerDeviations={this.getOwnerDetail}
                            getTargetOwnerDeviations={this.getTargetOwnerDetail}
                            clearTargetDeviations={this.props.clearTargetDeviations}
                            mergeContainer={this.mergeContainer}
                            searchOwnerType={this.state.searchOwnerType}
                        />
                        <AddNewOwnerNote
                            ownerData={this.props.ownerData?.ownerDetails}
                            refreshContainer={this.refreshNotes}
                            createNewNote={true}
                            hideDialog={this.props.hideDialog}
                        />
                    </>
                )}
            </>
        );
    }
}

const mapStateToProps = (state: IRootState): IOwnerPageStateProps => ({
    ownerSearchResults: selectors.tract.searchPagedOwnersResultsSelector(state),
    ownerDeviationsSearchResults: selectors.tract.searchOwnersDeviationsResults(state),
    ownerData: selectors.leaseGeneration.leaseGenerationOwnerData(state),
    isLoggedIn: selectors.auth.isLoggedIn(state),
    ownerDetails: selectors.owner.ownerDetailsSelector(state),
    targetOwnerDetails: selectors.owner.targetOwnerDetailsSelector(state),
    projectStaff: state.projectStaffing.staffing,
    ownershipContactCategories: state.ownershipContactCategories.categories,
    project: (clientNumber: number, projectNumber: number) => selectors.project.project(clientNumber, projectNumber)(state),
});

const mapDispatchToProps: IOwnerPageDispatchProps = {
    getPagedOwnerSearchResults: (clientNumber: number, projectNumber: number, options: ODataOptions) =>
        actions.tract.getSearchPagedOwners(clientNumber, projectNumber, options),
    getOwnerSearchDeviationsResults: (clientNumber: number, projectNumber: number, searchText: string, ownerType: string) =>
        actions.tract.getSearchOwnersDeviations(clientNumber, projectNumber, searchText, ownerType),
    getOwnerData: (clientId: number, projectId: number, ownerId: number) => actions.leaseGeneration.getOwnerData({ clientId, projectId, ownerId }),
    showDialog: (dialogName: string) => actions.layout.showDialog(dialogName),
    hideDialog: () => actions.layout.hideDialog(),
    getOwnerDetail: (clientNumber: number, projectNumber: number, ownerLookupId: number, containerId: number, type: string) =>
        actions.owner.getOwnerDetails(clientNumber, projectNumber, ownerLookupId, containerId, type),
    getTargetOwnerDetail: (clientNumber: number, projectNumber: number, ownerLookupId: number, containerId: number, type: string) =>
        actions.owner.getTargetOwnerDetails(clientNumber, projectNumber, ownerLookupId, containerId, type),
    changePrimary: (clientNumber: number, projectNumber: number, owner: IOwner) => actions.owner.changePrimary(clientNumber, projectNumber, owner),
    separateDeviation: (clientNumber: number, projectNumber: number, owner: IOwner) =>
        actions.owner.separateDeviation(clientNumber, projectNumber, owner),
    clearTargetDeviations: () => actions.owner.clearTargetDeviations(),
    mergeContainer: (clientNumber: number, projectNumber: number, primaryOwnerId: number, mergeContainer: MergeContainer) =>
        actions.owner.mergeContainer(clientNumber, projectNumber, primaryOwnerId, mergeContainer),
    navigate: (path: string) => push(path),
    getProjectDetails: (clientNumber: number, projectNumber: number) => actions.project.getProject(clientNumber, projectNumber),
    incrementPage: (clientNumber: number, projectNumber: number, options: ODataOptions) => 
        actions.tract.incrementOwnersPage(clientNumber, projectNumber, options),
    getProjectStaff: (clientNumber: number, projectNumber: number) => 
        actions.projectStaffing.getProjectStaffing(clientNumber, projectNumber),
    getOwnershipContactCategories: (clientNumber: number, projectNumber: number) =>
        actions.ownershipContactCategories.getOwnershipContactCategories(clientNumber, projectNumber),
    initOwnersPage: () =>
        actions.tract.initOwnersPage()
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OwnersPage));



// WEBPACK FOOTER //
// ./src/components/project/sections/OwnersPage.tsx